// extracted by mini-css-extract-plugin
export default {"Header":"PageHeader_Header__ncMYm","Title":"PageHeader_Title__86TiZ"};